import { useState } from "react";

interface LoginScreenProps {
  onSubmit: (loginPass: { emailOrUsername: string; password: string }) => void;
  submitDisabled: boolean;
}

const LoginScreenUI = (props: LoginScreenProps) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const submitEnabled =
    (login.length > 4 && password.length > 4) || props.submitDisabled;
  const handleSubmit = () => {
    props.onSubmit({ emailOrUsername: login, password });
  };
  return (
    <div className="flex h-dvh w-full flex-col items-center">
      <div
        className="flex h-full w-[80%] flex-col items-center justify-center"
      >
        <div className="m-0 py-[10px] text-center font-['Roboto'] text-[30px] font-bold text-[var(--color-primary)]">
          Cadendar Login
        </div>
        <input
          className="m-[3px] w-[300px] rounded-[5px] border-2 border-solid border-gray-100 bg-gray-50 p-2 text-[14px] text-gray-900 focus:border-gray-600 focus:outline-none"
          placeholder="Email/Login"
          value={login}
          onChange={(e) => {
            setLogin(e.target.value);
          }}
          onKeyUp={(e) => {
            if (e.key === "Enter" && submitEnabled) {
              handleSubmit();
            }
          }}
        />
        <input
          className="m-[3px] w-[300px] rounded-[5px] border-2 border-solid border-gray-100 bg-gray-50 p-2 text-[14px] text-gray-900 focus:border-gray-600 focus:outline-none"
          placeholder="Mot de passe"
          type={"password"}
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          onKeyUp={(e) => {
            if (e.key === "Enter" && submitEnabled) {
              handleSubmit();
            }
          }}
        />
        <button
          className="my-4 w-[300px] cursor-pointer rounded-[5px] bg-blue-800 p-2 text-[14px] text-white active:opacity-50 disabled:opacity-50"
          disabled={!submitEnabled}
          onClick={handleSubmit}
        >
          Submit
        </button>
        <div id="spacer" className="mt-[20px] h-[10dvh]"></div>
      </div>
    </div>
  );
};

export default LoginScreenUI;
